"use client";
import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { HeroSection } from "../components/heroComponent/HeroSection";
import { PartnersCarousel } from "../components/partnerComponent/PartnersCarousel";
import ServicesGrid from "../components/GridServices/ServicesGrid";
import { WorkingModes } from "../components/WorkModes/WorkingModes";
import { TechnologiesSection } from "../components/Technologies/TechnologiesSection";
import ContactUs from "../components/ContactUs";

export default function DigitalPage() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div className="bg-white">
      {/* Barra di progresso */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 to-green-500 z-[100] origin-left"
        style={{ scaleX }}
      />

      {/* Hero Section */}
      <HeroSection />
      <div className="relative">
        <PartnersCarousel />
        <ServicesGrid />
        <WorkingModes />
        <TechnologiesSection />
        <ContactUs />
      </div>
    </div>
  );
}
